<template>
  <div v-if="showModal" class="fixed inset-0 flex items-center justify-center z-50">
    <div class="absolute inset-0 bg-gray-800 opacity-75" />
    <div class="bg-white p-6 rounded-lg shadow-lg relative z-10 w-full max-w-md mx-4 sm:mx-auto">
      <h2 class="text-xl font-semibold mb-2 text-center">Seleziona Lettini</h2>
      <p class="text-left mb-2">
        Questo è un pacchetto FULL compreso di 2 ingressi, 2 lettini ed un tendone.
      </p>
      <p class="text-left mt-2 mb-4 text-sm">
        <b>Nota:</b> Si possono aggiungere un massimo di ulteriori 2 lettini antistanti il tendone ad un costo extra di 3 euro
        per ogni lettino. I lettini aggiuntivi non includono i biglietti d'ingresso.
      </p>

      <hr />

      <p class="text-left mt-4 mb-2">
        Opzioni aggiuntive:
      </p>

      <div class="flex flex-col md:flex-row mt-4 sm:text-center items-center">
        <div class="w-full lg:w-full">
          <p class="text-lg text-left font-semibold">Lettini</p>
        </div>
        <div class="w-full lg:w-full mt-4 md:mt-0 flex justify-center space-x-2 mx-auto">
          <button
            :disabled="sunbeds <= 0"
            class="bg-gray-300 text-gray-700 px-3 rounded"
            type="button"
            @click="decreaseSunbeds"
          >
            -
          </button>
          <input
            v-model="sunbeds"
            class="w-16 text-center border border-gray-300 rounded [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            max="4"
            min="2"
            readonly
            type="number"
          />
          <button
            :disabled="sunbeds >= 2"
            class="bg-gray-300 text-gray-700 px-3 rounded"
            type="button"
            @click="increaseSunbeds"
          >
            +
          </button>
        </div>
      </div>
      <div class="flex flex-col mt-2 md:flex-row sm:text-center items-center">
        <div class="w-full lg:w-full">
          <p class="text-lg text-left font-semibold">Adulti</p>
        </div>
        <div class="w-full lg:w-full mt-4 md:mt-0 flex justify-center space-x-2 mx-auto">
          <button
            :disabled="adults <= 0"
            class="bg-gray-300 text-gray-700 px-3 rounded"
            type="button"
            @click="decreaseAdults"
          >
            -
          </button>
          <input
            v-model="adults"
            class="w-16 text-center border border-gray-300 rounded [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            max="4"
            min="2"
            readonly
            type="number"
          />
          <button
            class="bg-gray-300 text-gray-700 px-3 rounded"
            type="button"
            @click="increaseAdults"
          >
            +
          </button>
        </div>
      </div>

      <div class="flex justify-end space-x-2 mt-8">
        <button class="bg-red-500 hover:bg-red-700 text-white px-4 py-2 rounded" type="button" @click="closeModal">
          Chiudi
        </button>
        <button class="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded" type="button"
                @click="confirmSelection">
          Conferma
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import NumberInput from "@/Pages/Home/Checkout/partials/NumberInput.vue";

export default {
  components: { NumberInput },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close", "confirm"],
  data() {
    return {
      sunbeds: 0, // Initial value for sunbeds
      adults: 0, // Initial value for adult entrances
    };
  },
  methods: {
    increaseSunbeds() {
      if (this.sunbeds < 2) {
        this.sunbeds += 1;
      }
    },
    decreaseSunbeds() {
      if (this.sunbeds > 0) {
        this.sunbeds -= 1;
      }
    },
    increaseAdults() {
      this.adults += 1;
    },
    decreaseAdults() {
      if (this.adults > 0) {
        this.adults -= 1;
      }
    },
    closeModal() {
      this.$emit("close");
    },
    confirmSelection() {
      this.$emit("confirm", this.sunbeds, this.adults);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
/* Add any additional styling if necessary */
</style>
